import React from "react";
import PropTypes from "prop-types";
import isEmpty from "lodash-es/isEmpty";

import DialogForm from "ui/Dialog";
import ListItemText from "ui/List/ListItemText";
import Button from "ui/Button";
import Typography from "ui/Typography";

import useExecuteQuery from "hooks/useExecuteQuery";
import useSnackbars from "hooks/useSnackbars";

import { READ_REPO_INFO_QUERY } from "graphqlQueries/system";
import { GetRepoInfoMapper } from "graphqlQueries/system.map";

import FullLogo from "assets/svg/full-logo.svg";
import CopyIcon from "assets/svg/copy.svg";

const AboutDialog = (props) => {
  const { onClose } = props;
  const { data, loading } = useExecuteQuery(READ_REPO_INFO_QUERY, {
    dataMapper: GetRepoInfoMapper,
    ignoreNoPermission: true,
  });
  const { successSnackbar } = useSnackbars();

  const renderActions = () => {
    return (
      <>
        <Button
          id="close-about-dialog-button"
          variant="text"
          onClick={onClose}
          color="primary"
        >
          Close
        </Button>
        <Button
          id="copy-about-dialog-button"
          variant="contained"
          onClick={onCopy}
          color="primary"
          startIcon={<CopyIcon width="20px" />}
          disabled={loading}
        >
          Copy
        </Button>
      </>
    );
  };

  const onCopy = async () => {
    const dataToCopy = JSON.stringify(data);
    await navigator.clipboard.writeText(dataToCopy);
    successSnackbar("Copied");
  };

  const renderContent = () => {
    if (isEmpty(data)) {
      return (
        <Typography variant="h6" align="center">
          {"Info isn't available"}
        </Typography>
      );
    }

    return Object.entries(data).map(([name, value]) => (
      <ListItemText
        key={`server-info-item-${name}`}
        heading={name}
        description={value}
      />
    ));
  };

  return (
    <DialogForm
      initialValues={{}}
      onClose={onClose}
      Icon={FullLogo}
      headerIconSize="140px"
      onSubmit={() => {}}
      renderActionsFunc={renderActions}
      preLoading={loading}
      preLoadingHeight="400px"
      className="dialog-about-width"
    >
      {renderContent()}
    </DialogForm>
  );
};

AboutDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default AboutDialog;
